// PO32
import React from 'react';
import Modal from 'react-modal';
import classnames from 'classnames';
import CloseIconBold from '../../Icons/CloseBold';
import IconButton from '../../Button/IconButton';
import ErrorBoundary from '../../ErrorBoundary';
import s from './LightBox.scss';
export var LightBoxPopup = function (_a) {
    var className = _a.className, contentClassName = _a.contentClassName, overlayClassName = _a.overlayClassName, closeBtnClassName = _a.closeBtnClassName, closeBtnSize = _a.closeBtnSize, onRequestClose = _a.onRequestClose, children = _a.children;
    return (React.createElement(Modal, { isOpen: true, className: classnames(s['root'], className), overlayClassName: classnames(s['overlay'], overlayClassName), onRequestClose: onRequestClose },
        React.createElement("div", { className: classnames(s['content'], contentClassName) },
            React.createElement(IconButton, { className: s['close-button'], onClick: onRequestClose, noHoverEffect: true },
                React.createElement(CloseIconBold, { className: classnames(s['close-icon'], closeBtnClassName), size: closeBtnSize })),
            React.createElement(ErrorBoundary, null, children))));
};
LightBoxPopup.displayName = 'LightBoxPopup';
export default LightBoxPopup;
//# sourceMappingURL=LightBox.js.map